import React from "react";

const ViewQuotationDetails = ({ quotation, closeView }) => {
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return new Date(dateString)
      .toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      })
      .replace(/\//g, "-");
  };

  const createdDate = quotation.quatation?.createdDate
    ? formatDate(quotation.quatation.createdDate)
    : "N/A";
  const quotationSentDate = quotation.quatation?.quatationDate
    ? formatDate(quotation.quatation.quatationDate)
    : "N/A";
  const pendingDate = quotation.quatation?.pendingDate
    ? formatDate(quotation.quatation.pendingDate)
    : "N/A";
  const rejectedDate = quotation.quatation?.rejectedDate
    ? formatDate(quotation.quatation.rejectedDate)
    : "N/A";

  // Dynamically generate email based on customerEmail or customerName
  const email = quotation.salesEnquiry?.customerEmail
    ? quotation.salesEnquiry.customerEmail
    : `${quotation.salesEnquiry?.customerName?.toLowerCase().replace(/\s+/g, "") || "unknown"}@gmail.com`;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 px-4">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-5xl max-h-[90vh] overflow-y-auto p-6">
        {/* Header */}
        <div className="flex gap-10 items-center mb-6 justify-start">
          <button
            className="text-[#2b6e73] border border-[#2b6e73] rounded-full w-9 h-9 flex items-center justify-center"
            onClick={closeView}
          >
            ←
          </button>

          <h2 className="text-2xl font-bold text-[#2b6e73] justify-center">
            Quotation Management{" "}
            <span className="text-base font-normal text-gray-500 justify-center">
              - {quotation.quatation?.status || "N/A"}
            </span>
          </h2>
        </div>

        {/* Info Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {/* Quotation Information */}
          <div className="bg-gray-50 p-4 rounded-lg">
            <h3 className="text-lg font-semibold text-[#2b6e73] mb-2">Quotation Information</h3>
            <div className="grid grid-cols-1 gap-2 text-sm leading-6">
              <div className="grid grid-cols-[140px_10px_1fr] items-center">
                <span className="font-semibold text-gray-600">Quotation Status</span>
                <span className="text-gray-600">:</span>
                <span className="font-medium text-gray-800">
                  {quotation.quatation?.status || "N/A"}
                </span>
              </div>
              <div className="grid grid-cols-[140px_10px_1fr] items-center">
                <span className="font-semibold text-gray-600">RFQ No</span>
                <span className="text-gray-600">:</span>
                <span className="font-medium text-gray-800">
                  {quotation.salesEnquiry?.rfqNo || "N/A"}
                </span>
              </div>
              <div className="grid grid-cols-[140px_10px_1fr] items-center">
                <span className="font-semibold text-gray-600">Quotation No</span>
                <span className="text-gray-600">:</span>
                <span className="font-medium text-gray-800">
                  {quotation.quatation?.orderNo || "N/A"}
                </span>
              </div>
              {/* <div className="grid grid-cols-[140px_10px_1fr] items-center">
                <span className="font-semibold text-gray-600">SalesOrder No</span>
                <span className="text-gray-600">:</span>
                <span className="font-medium text-gray-800">
                  {quotation.salesOrderNo || "N/A"}
                </span>
              </div> */}
              <div className="grid grid-cols-[140px_10px_1fr] items-center">
                <span className="font-semibold text-gray-600">Assignee Name</span>
                <span className="text-gray-600">:</span>
                <span className="font-medium text-gray-800">
                  {quotation.quatation?.assigneeName || "N/A"}
                </span>
              </div>
            </div>
          </div>

          {/* Customer Information */}
          <div className="bg-gray-50 p-4 rounded-lg mt-2">
            <h3 className="text-lg font-semibold text-[#2b6e73] mb-2">Customer Information</h3>
            <div className="grid grid-cols-1 gap-2 text-sm leading-6">
              <div className="flex items-center">
                <span className="font-semibold text-gray-600 min-w-[100px]">Name</span>
                <span className="w-[10px] text-gray-600">:</span>
                <span className="font-medium text-gray-800">
                  {quotation.salesEnquiry?.customerName || "N/A"}
                </span>
              </div>
              <div className="flex items-center">
                <span className="font-semibold text-gray-600 min-w-[100px]">Company</span>
                <span className="w-[10px] text-gray-600">:</span>
                <span className="font-medium text-gray-800">
                  {quotation.salesEnquiry?.companyName || "N/A"}
                </span>
              </div>
              <div className="flex items-center">
                <span className="font-semibold text-gray-600 min-w-[100px]">Mobile Number</span>
                <span className="w-[10px] text-gray-600">:</span>
                <span className="font-medium text-gray-800">
                  {quotation.salesEnquiry?.mobileNumber || "N/A"}
                </span>
              </div>
              <div className="flex items-center">
                <span className="font-semibold text-gray-600 min-w-[100px]">Email</span>
                <span className="w-[10px] text-gray-600">:</span>
                <span className="font-medium text-gray-800">
                  {email || "N/A"}
                </span>
              </div>
              <div className="flex items-center">
                <span className="font-semibold text-gray-600 min-w-[100px]">Address</span>
                <span className="w-[10px] text-gray-600">:</span>
                <span className="font-medium text-gray-800">
                  {quotation.salesEnquiry?.address || "N/A"}
                </span>
              </div>
            </div>
          </div>

          {/* Quotation Status */}
          <div>
            <h3 className="text-lg font-semibold text-[#2b6e73] mb-2">Quotation Status</h3>
            <ul className="space-y-2">
              <li className="flex justify-between items-center bg-green-100 p-2 rounded">
                <span className="text-green-500">Quotation Received</span>
                <span className="ml-2 font-medium text-green-500">
                  {quotationSentDate}
                </span>
              </li>
              <li className="flex justify-between items-center bg-yellow-100 p-2 rounded">
                <span className="text-yellow-500">Pending</span>
                <span className="ml-2 font-medium text-yellow-500">
                  {pendingDate}
                </span>
              </li>
              <li className="flex justify-between items-center bg-red-100 p-2 rounded">
                <span className="text-red-500">Rejected</span>
                <span className="ml-2 font-medium text-red-500">
                  {rejectedDate}
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Quotation Products */}
        <div className="mt-8">
          <h3 className="text-lg font-semibold mb-2">Quotation Products</h3>
          <div className="overflow-x-auto">
            <table className="min-w-full border text-sm text-center">
              <thead className="bg-[#2b6e73] text-white">
                <tr>
                  <th className="p-3">Product</th>
                  <th className="p-3">CAS Number</th>
                  <th className="p-3">Catalog Number</th>
                  <th className="p-3">Date</th>
                  <th className="p-3">HSN Code</th>
                  <th className="p-3">Quantity</th>
                </tr>
              </thead>
              <tbody className="bg-white">
                {quotation.salesEnquiry?.products?.map((product, index) => (
                  <tr key={index} className="border-b hover:bg-gray-50">
                    <td className="p-3">{product.productName || "N/A"}</td>
                    <td className="p-3">{product.casNumber || "N/A"}</td>
                    <td className="p-3">{product.catalogNumber || "N/A"}</td>
                    <td className="p-3 text-center text-gray-800">
                      {formatDate(quotation.quatation?.quatationDate)}
                    </td>
                    <td className="p-3">{product.hsnCode || "N/A"}</td>
                    <td className="p-3">{product.quantity || "N/A"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Footer Action */}
        <div className="mt-6 justify-start">
          <button
            className="text-[#2b6e73] border border-[#2b6e73] px-4 py-2 rounded hover:bg-green-50"
            onClick={closeView}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ViewQuotationDetails;